import { render } from "./AddModeReglementModal.vue?vue&type=template&id=fb917276&ts=true"
import script from "./AddModeReglementModal.vue?vue&type=script&lang=ts"
export * from "./AddModeReglementModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__